import React, { useState } from 'react';
import Translator from '../../../core/i18n';
import WillBeSentActivities from './tables/willBeSentActivities';
import InProcessActivities from './tables/inProcessActivities';
import SentActivities from './tables/sentActivities';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { IMainMadlenIntegrationProps } from '../../../models/components/madlen-integrations';


const T = Translator.create();

const MadlenIntegration: React.FC<IMainMadlenIntegrationProps> = ({ courseId, classId }) => {

    const [key, setKey] = useState('willBeSentActivities');

    return (
        <div>
            <span className='cursor-default' style={{ fontWeight: "bold" }}>
                {T.t('r_madlen_content_sync')}
            </span>
            <hr className="bottom-border-2 mx-0" />
            <Tabs
                defaultActiveKey="profile"
                id="uncontrolled-tab-example"
                className="mb-3"
                activeKey={key}
                onSelect={(k) => k && setKey(k)}
            >
                <Tab eventKey="willBeSentActivities" title={T.t('r_tab_will_be_sent')}>
                    {key === 'willBeSentActivities' && (
                        <WillBeSentActivities courseId={courseId} classId={classId} />
                    )}
                </Tab>
                <Tab eventKey="inProcessActivities" title={T.t('r_tab_in_process')}>
                    {key === 'inProcessActivities' && (
                        <InProcessActivities courseId={courseId} classId={classId} />
                    )}
                </Tab>
                <Tab eventKey="sentActivities" title={T.t('r_tab_sent')}>
                    {key === 'sentActivities' && (
                        <SentActivities courseId={courseId} classId={classId} />
                    )}
                </Tab>
            </Tabs>
        </div>
    );
};
export default MadlenIntegration;